/**
 * 网站公告列表页路径
 */
export const NOTICE_LIST_PAGE_PATH = '/notice/list'

/**
 * 网站公告详情页路径
 */
export const NOTICE_DETAIL_PAGE_PATH = '/notice/detail'
